import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry
 */
import { take } from 'redux-saga/effects';
import globals from '../../../globals/globals';
import extractJson from '../../../extract-json/extract-json';
import logger from '../../../logger/logger';
import { initializeFraudDetection } from '../../../fraud/trusteer';
import * as actions from '../actions';
export var watchInitializeTrusteer = /*#__PURE__*/regeneratorRuntime.mark(function watchInitializeTrusteer() {
  var _yield$take, payload, _ref, dt, mobile, _globals, securitySessionContext, _yield$extractJson, providers, trusteer, uri, sessionId;

  return regeneratorRuntime.wrap(function watchInitializeTrusteer$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 26;
            break;
          }

          _context.next = 3;
          return take(actions.TRUSTEER_INITIALIZE);

        case 3:
          _yield$take = _context.sent;
          payload = _yield$take.payload;
          _ref = payload || {}, dt = _ref.dt;
          mobile = payload && typeof payload.mobile === 'boolean' ? payload.mobile : globals().nativeWrapped;
          _context.prev = 7;
          _globals = globals(), securitySessionContext = _globals.securitySessionContext;

          if (!securitySessionContext) {
            _context.next = 18;
            break;
          }

          _context.next = 12;
          return extractJson(securitySessionContext);

        case 12:
          _yield$extractJson = _context.sent;
          providers = _yield$extractJson.externalDataProviderInfo;
          trusteer = providers.filter(function (provider) {
            return 'TRUSTEER' === provider.dataProvider;
          });

          if (trusteer[0]) {
            uri = trusteer[0].url;
            sessionId = trusteer[0].additionalInfoList[0].value;
            initializeFraudDetection({
              uri: uri,
              sessionId: sessionId,
              mobile: mobile,
              dt: dt
            });
          }

          _context.next = 19;
          break;

        case 18:
          logger.warn('TRUSTEER: (WARNING) securitySessionContext is not defined');

        case 19:
          _context.next = 24;
          break;

        case 21:
          _context.prev = 21;
          _context.t0 = _context["catch"](7);
          logger.error('TRUSTEER: (ERROR) exception in initialize', _context.t0);

        case 24:
          _context.next = 0;
          break;

        case 26:
        case "end":
          return _context.stop();
      }
    }
  }, watchInitializeTrusteer, null, [[7, 21]]);
});